import { ChangeEvent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SelectBedsMinOptions } from '../../../search/common/SelectBedsOptions';
import {
    updateFilter,
    bedsMinSelector,
    bedsMaxSelector
} from '@zoopla/redux-reducer-filters';
import {
    FilterWrapper,
    StyledDropdownWithLabel
} from './SearchInitiationMobile.styles';

export const SelectBedsToRent = () => {
    const reduxDispatch = useDispatch();
    const { selectedValue: bedsMinSelectedValue, options: bedsMinOptions } =
        useSelector(bedsMinSelector);
    const { selectedValue: bedsMaxSelectedValue } =
        useSelector(bedsMaxSelector);

    const onMinBedsChange = (evt: ChangeEvent<HTMLSelectElement>) => {
        const {
            currentTarget: { value }
        } = evt;

        reduxDispatch(updateFilter('minBedrooms', value));
    };

    const bedsMaxInt = parseInt(bedsMaxSelectedValue, 10);

    const minBedsLabel = 'Min beds';
    const bedsOptionsLabel = 'Any beds';

    const bedsMinOptionsShort = bedsMinOptions.map((o) => {
        if (o.label.match(/^\d+$/)) return { ...o, label: o.label + '+' };
        return o;
    });

    return (
        <FilterWrapper>
            <StyledDropdownWithLabel
                id="mobile_beds_min"
                onChange={onMinBedsChange}
                value={bedsMinSelectedValue}
                name="beds_min"
                aria-label="Min Beds"
                data-testid="min_beds_mobile"
                label={minBedsLabel}
                hasBorderRadius
            >
                {bedsMinOptions ? (
                    <SelectBedsMinOptions
                        bedsOtherInt={bedsMaxInt}
                        options={bedsMinOptionsShort}
                        keyPrefix="modal-min-beds"
                    />
                ) : (
                    <option>{bedsOptionsLabel}</option>
                )}
            </StyledDropdownWithLabel>
        </FilterWrapper>
    );
};
